/**
 * Field value for dynamic form fields
 * NOTE: versionFieldId changed from number to string to support UUID field IDs
 */
export class CaseFieldValueEntity {
  public versionFieldId!: string;
  public value!: string | null;
}
